import { createRouteContext } from '@/providers';
import { ExecutiveSummaryRoute } from '@/types/routes';

const { RouteProvider: ExecutiveSummaryRouteProvider, useRouteContext: useExecutiveSummaryRoute } =
    createRouteContext<ExecutiveSummaryRoute>();

export { ExecutiveSummaryRouteProvider, useExecutiveSummaryRoute };
